import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-feiji",
  "use": "icon-feiji-usage",
  "viewBox": "0 0 1216 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1216 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-feiji\"><path d=\"M1136.602255 34.38405L80.449861 442.419135c-59.483305 22.977803-57.995534 56.397557 3.030646 74.526327l255.207899 75.793688 103.758281 309.098286c13.582802 40.472893 49.041354 48.986251 79.430462 18.900208L655.721473 787.967821l264.217182 193.851104c34.328948 25.181909 69.622192 11.929723 78.879436-29.865633l192.831706-869.795249c9.229693-41.685151-15.373638-63.092528-55.047542-47.773993z m-160.706864 196.688891L525.376167 632.881427c-8.100089 7.245998-15.456292 21.545134-16.585896 32.152393l-19.864504 187.183685c-2.259208 21.04921-9.505206 21.903301-16.172626 1.735733l-87.144833-263.060026a25.126806 25.126806 0 0 1 10.331746-28.350311L967.271827 219.473834c36.4504-21.848199 40.307585-16.723653 8.623564 11.599107z m0 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/feiji.svg
// module id = hIih
// module chunks = 12